import { useCallback, useState } from 'react';
import { RequestInfo } from './types';

// Use the original fetch to completely bypass the interceptor wrapper
const originalFetch = (window as any).fetchOriginal || window.fetch;

const useFetchRequest = () => {
  const [requestData, setRequestData] = useState<RequestInfo | null>(null);

  const send = useCallback(async (url: string, requestHeaders: Record<string, string>) => {
    const startTime = performance.now();
    setRequestData({
      method: 'POST',
      url: url,
      status: 'pending',
      startTime,
    });

    try {
      const responseStartTime = performance.now();
      // Use originalFetch to completely bypass the wrapper
      const response = await originalFetch(url, {
        method: 'POST',
        body: JSON.stringify({}),
        headers: requestHeaders,
      });
      const responseEndTime = performance.now();
      const responseTime = responseEndTime - responseStartTime;

      const headers: Record<string, string> = {};
      response.headers.forEach((value: string, key: string) => {
        headers[key] = value;
      });

      const responseBody = await response.text();
      const responseSize = new Blob([responseBody]).size;

      setRequestData({
        method: 'POST',
        url: url,
        status: 'completed',
        statusCode: response.status,
        statusText: response.statusText,
        headers,
        responseTime,
        responseSize,
        responseBody,
        startTime,
      });
    } catch (error) {
      setRequestData({
        method: 'POST',
        url: url,
        status: 'error',
        error: error instanceof Error ? error.message : 'Unknown error',
        startTime,
      });
    }
  }, []);

  return [requestData, send] as const;
};

export default useFetchRequest;
